var map = {
	"./bh-ico-active.svg": 1770,
	"./bh-ico.svg": 1771,
	"./bonus-ico-active.svg": 1772,
	"./bonus-ico.svg": 1773,
	"./deposit-ico.svg": 1774,
	"./deposit-ico.webp": 1775,
	"./edit-icon.svg": 1776,
	"./fb-ico.svg": 1777,
	"./instant-rebate-ico-active.svg": 1778,
	"./instant-rebate-ico.svg": 1779,
	"./mall-ico-active.svg": 1780,
	"./mall-ico.svg": 1781,
	"./msg-ico-active.svg": 1782,
	"./msg-ico.svg": 1783,
	"./pi-ico-active.svg": 1784,
	"./pi-ico.svg": 1785,
	"./rf-ico-active.svg": 1786,
	"./rf-ico.svg": 1787,
	"./rh-ico-active.svg": 1788,
	"./rh-ico.svg": 1789,
	"./th-ico-active.svg": 1790,
	"./th-ico.svg": 1791,
	"./vip-ico-active.svg": 1792,
	"./vip-ico.svg": 1793,
	"./withdrawal-ico.svg": 1794,
	"./withdrawal-ico.webp": 1795,
	"./wl-ico-active.svg": 1796,
	"./wl-ico.svg": 1797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 470;